<template>
  <ModalPanel :open="open" :initial-focus="cancelButton" @close="cancel">
    <div class="sm:flex sm:items-start">
      <div
        class="mx-auto flex size-12 shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:size-10 dark:bg-red-500/10"
      >
        <ExclamationTriangleIcon class="size-6 text-red-600 dark:text-red-400" aria-hidden="true" />
      </div>
      <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
        <DialogTitle as="h3" class="text-base font-semibold text-gray-900 dark:text-white">
          {{ title }}
        </DialogTitle>
        <p class="mt-2 text-sm text-gray-500 dark:text-gray-400">{{ message }}</p>
        <p v-if="error" class="mt-2 text-sm text-red-600 dark:text-red-400" role="alert">
          {{ error }}
        </p>
      </div>
    </div>
    <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse gap-3">
      <button
        type="button"
        :disabled="busy"
        class="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-red-500 disabled:cursor-wait disabled:opacity-50 sm:w-auto dark:bg-red-500 dark:hover:bg-red-400 cursor-pointer"
        data-testid="confirm-dialog-confirm"
        @click="emit('confirm')"
      >
        {{ busy ? busyLabel : confirmLabel }}
      </button>
      <button
        ref="cancelButton"
        type="button"
        :disabled="busy"
        class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-xs inset-ring inset-ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto dark:bg-white/10 dark:text-white dark:inset-ring-white/5 dark:hover:bg-white/20 cursor-pointer"
        @click="cancel"
      >
        Cancel
      </button>
    </div>
  </ModalPanel>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { DialogTitle } from '@headlessui/vue';
import { ExclamationTriangleIcon } from '@heroicons/vue/24/outline';
import ModalPanel from '@/components/ModalPanel.vue';

const props = defineProps<{
  open: boolean;
  title: string;
  message: string;
  confirmLabel: string;
  busyLabel: string;
  busy?: boolean;
  error?: string | null;
}>();

const emit = defineEmits<{
  (e: 'confirm'): void;
  (e: 'cancel'): void;
}>();

const cancelButton = ref<HTMLButtonElement | null>(null);

function cancel() {
  if (props.busy) return;
  emit('cancel');
}
</script>
